import axiosInstance from "./instance";

const instance = axiosInstance();
const headers = new Headers({ 'Content-Type': 'application/octet-stream' });

export const uploadWriteToUs = async (userId, file) => {
    try {
        const response = await instance.post(`/help-desk/upload/${userId}`, file,{
            headers: headers
        });
        console.log("upload responce-->", response);
        return response;
    } catch (error) {
        console.log("upload error-->", error);
        return error;
    }
}

export const uploadHelpDesk = async (userId, file) => {
    try {
        const response = await instance.post(`/help-desk`, file);
        console.log("upload responce-->", response);
        return response;
    } catch (error) {
        console.log("upload error-->", error);
        return error;
    }
}